import React from 'react';
import { useOptionalAuth } from '../contexts/AuthContext';
import { getBrowserTz } from '../lib/timezone';

// The timezone a session list should render in, plus a setter for the TimezoneSelect override.
// Order matters (TTT-14): the viewer's *saved* profile timezone wins over the browser's, so a
// student who set Asia/Tokyo sees GMT+9 even while browsing from a GMT+8 machine.
//
// Derived rather than an effect on purpose — /auth/me resolves after the first render, and a
// useState initializer would freeze the browser tz before the user ever arrives.
export function useViewerTz() {
  const auth = useOptionalAuth();
  const [override, setOverride] = React.useState(null);
  return [override || auth?.user?.timezone || getBrowserTz(), setOverride];
}
